import { RootState } from '../root.reducers';
import { NetworkId } from './networkId.types';

export const getNetworkIdList = (state: RootState): NetworkId[] =>
  state.networkId.entities;

export const getNetworkId = (state: RootState): NetworkId | null =>
  state.networkId.single;

export const getSelectedNetworkId = (state: RootState): NetworkId[] =>
  state.networkId.selected;

export const getNetworkIdCreatedId = (state: RootState): string | null =>
  state.networkId.createdId;

export const isNetworkIdCreatePopupOpen = (state: RootState): boolean =>
  state.networkId.ui.isCreatePopupOpen;

export const isNetworkIdLoading = (state: RootState): boolean =>
  state.networkId.ui.isLoading;

export const getNetworkIdListToSipSettings = (state: RootState): NetworkId[] | undefined =>
  state.networkId.networksToSipSettings;
